import { render, staticRenderFns } from "./NewHearing.vue?vue&type=template&id=4f944a79&scoped=true"
import script from "./NewHearing.vue?vue&type=script&lang=js"
export * from "./NewHearing.vue?vue&type=script&lang=js"
import style0 from "./NewHearing.vue?vue&type=style&index=0&id=4f944a79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f944a79",
  null
  
)

export default component.exports